import strings from '../../../globalization';
export const getFormData = () => {
  return [
    {
      elementType: 'text',
      keyboardType: 'default',
      inputType: 'specialName',
      label: strings.masterAdminName,
      placeholder: strings.masterAdminNamePlaceholder,
      required: true,

      stateField: 'name',
      error: ' At Least Four Characters Required',
      stateDefault: '',
      minLength: 3,
      maxLength: 120,
      dependentOnOtherFields: false,
    },
    {
      elementType: 'text',
      keyboardType: 'default',
      inputType: 'hindiName',

      label: strings.masterAdminNameHindi,
      placeholder: strings.masterAdminNameHindiPlaceholder,
      error: ' At Least Four Characters Required',
      required: true,
      stateField: 'name_hindi',
      stateDefault: '',
      minLength: 3,
      maxLength: 120,
      dependentOnOtherFields: false,
    },
    {
      elementType: 'text',
      keyboardType: 'default',
      inputType: 'number',

      label: 'Error Code',
      placeholder: 'Enter Error Code',
      error: ' At Least Four Characters Required',
      required: true,
      stateField: 'errorCode',
      stateDefault: '',
      minLength: 3,
      maxLength: 120,
      dependentOnOtherFields: false,
    },
  ];
};
